import React from 'react';
import PropTypes from 'prop-types';
import { OnVisible } from '@americanexpress/data-manager-utils';
import MarketingTile from '../MarketingTile/MarketingTile';
import { GUEST } from '../../constants/cardTypeConstants';

const BottomTiles = ({ leftRowTile, rightRowTile, cardType }) => (
  <>
    <div className="row">
      <div className="col-md-6 margin-4-b pad-2-lr-sm-down pad-3-l-md-up pad-1-r-md-up pad-2-lr-lg-up">
        <MarketingTile index={3} content={leftRowTile} />
      </div>
      <div className="col-md-6 margin-4-b pad-2-lr-sm-down pad-1-l-md-up pad-3-r-md-up pad-2-r-lg-up">
        <MarketingTile index={4} content={rightRowTile} />
      </div>
    </div>
    <OnVisible
      analyticsInfo={{
        element: `hp-${cardType}`,
        detail: 'hp-tiles-L3-banner-hp-tiles-L4-banner',
      }}
    >
      <span />
    </OnVisible>
  </>
);

BottomTiles.propTypes = {
  leftRowTile: PropTypes.shape({}).isRequired,
  rightRowTile: PropTypes.shape({}).isRequired,
  cardType: PropTypes.string,
};

BottomTiles.defaultProps = {
  cardType: GUEST,
};

export default BottomTiles;
